import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { GlobalSettingsAppsSidebar as GlobalAppsSettingsSidebarType } from './ui/index.tsx';

const LazyGlobalAppsSettingsSidebar = lazyAfterPaint<typeof GlobalAppsSettingsSidebarType>(() => {
	setPerformanceMarkLoadStart();
	return import(/* webpackChunkName: "async-sidebar-global-settings-apps" */ './index').then(
		(bundle) => {
			setPerformanceMarkLoadEnd();
			return bundle;
		},
	);
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GlobalAppsSettingsSidebar = memo<Record<any, any>>(() => (
	<SidebarBoundary id="globalAppsSettings">
		<LazyGlobalAppsSettingsSidebar />
	</SidebarBoundary>
));

GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';

export default GlobalAppsSettingsSidebar;
